import React, { useEffect, useState } from 'react';
import { Container } from '@mui/material';
import Selected from 'src/components/domain/Selected';
import useStore from 'src/store/cns';
import { useLocation, useNavigate } from 'react-router-dom';
import { handleError } from 'src/utils/errors/common';
import { updateDomains } from 'src/utils/data/domains';
import Domains from 'src/components/category/show/Domains';

const MyDomains = () => {
  const wallet = useStore(state => state.wallet);
  const domains = useStore(state => state.domains);
  const setDomains = useStore(state => state.setDomains);

  const navigate = useNavigate();
  const location = useLocation();

  const [selectedDomain, setSelectedDomain] = useState<Domain | undefined>();

  useEffect(() => {
    if (location.state?.selectedDomain) {
      setSelectedDomain(location.state?.selectedDomain);
    }

    if (!wallet) {
      navigate('/cns', {
        state: {
          registerState: {
            domainName: '',
            status: 'searching',
          },
        },
      });
    } else if (domains.length === 0) {
      fetchData();
    } else if (selectedDomain) {
      setDomains(updateDomain(domains, selectedDomain));
    }
  }, [selectedDomain]);

  const fetchData = async () => {
    try {
      await updateDomains();
    } catch (error) {
      handleError(error, 'Failed to query logs');
    }
  };

  const updateDomain = (domains: Domain[], updatedDomain: Domain): Domain[] => {
    const updateDomainRecursive = (domainList: Domain[]): Domain[] => {
      return domainList.map(domain => {
        if (domain.name === updatedDomain.name) {
          return updatedDomain;
        }

        if (domain.subdomains.length > 0) {
          return {
            ...domain,
            subdomains: updateDomainRecursive(domain.subdomains),
          };
        }

        return domain;
      });
    };

    return updateDomainRecursive(domains);
  };

  return (
    <Container maxWidth="md" sx={{ mt: 8 }}>
      {selectedDomain && wallet ? (
        <Selected
          selectedDomain={selectedDomain}
          wallet={wallet}
          selectDomain={setSelectedDomain}
        />
      ) : (
        <Domains selectDomain={setSelectedDomain} domains={domains} />
      )}
    </Container>
  );
};

export default MyDomains;
